import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=f641c97c&scoped=true&"
import script from "./journal.vue?vue&type=script&lang=js&"
export * from "./journal.vue?vue&type=script&lang=js&"
import style0 from "./journal.vue?vue&type=style&index=0&id=f641c97c&lang=less&scoped=true&"
import style1 from "./journal.vue?vue&type=style&index=1&id=f641c97c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f641c97c",
  null
  
)

export default component.exports